import { useMantineTheme } from "@mantine/core";
import { useState } from "react";
import { ChevronRight } from "@/public/icons/ChevronRight";
import { getBreakpoint } from "@/utils/mantine";
import HydratedMediaQuery from "@/utils/hydratedMediaQuery";
import styles from "./Carrousel.module.scss";
import { Slide, SlideProps } from "./slide/Slide";
import { Category } from "../category/Category";

export type CarrouselProps = {
  title: string;
  subTitle: string;
  slides: SlideProps[];
};

export const Carrousel = ({ title, slides, subTitle }: CarrouselProps) => {
  const theme = useMantineTheme();
  const isTabletOrDesktop = HydratedMediaQuery(
    getBreakpoint(theme.breakpoints.md)
  );
  const showSecondImage = isTabletOrDesktop && slides.length > 1;
  const showThirdImage = isTabletOrDesktop && slides.length > 2;
  const showFourthImage = isTabletOrDesktop && slides.length > 3;

  const showArrow =
    (isTabletOrDesktop && slides.length > 4) ||
    (!isTabletOrDesktop && slides.length > 1);

  const [displayedFirstImageIndex, setDisplayedFirstImageIndex] =
    useState<number>(0);
  const [displayedSecondImageIndex, setDisplayedSecondImageIndex] =
    useState<number>(1);
  const [displayedThirdImageIndex, setDisplayedThirdImageIndex] =
    useState<number>(2);
  const [displayedFourthImageIndex, setDisplayedFourthImageIndex] =
    useState<number>(3);

  const changeDisplayImage = (isNext: boolean) => {
    if (isNext) {
      setDisplayedFirstImageIndex(
        (displayedFirstImageIndex + 1) % slides.length
      );
      setDisplayedSecondImageIndex(
        (displayedSecondImageIndex + 1) % slides.length
      );
      setDisplayedThirdImageIndex(
        (displayedThirdImageIndex + 1) % slides.length
      );
      setDisplayedFourthImageIndex(
        (displayedFourthImageIndex + 1) % slides.length
      );
    } else {
      setDisplayedFirstImageIndex(
        (displayedFirstImageIndex - 1 + slides.length) % slides.length
      );
      setDisplayedSecondImageIndex(
        (displayedSecondImageIndex - 1 + slides.length) % slides.length
      );
      setDisplayedThirdImageIndex(
        (displayedThirdImageIndex - 1 + slides.length) % slides.length
      );
      setDisplayedFourthImageIndex(
        (displayedFourthImageIndex - 1 + slides.length) % slides.length
      );
    }
  };

  const returnSlide = (slideIndex: number) => (
    <Slide {...slides[slideIndex]} key={slides[slideIndex].label} />
  );

  return (
    <div className={styles.carrousel}>
      <div className={styles.slider}>
        {showArrow && (
          <div
            className={styles.chevronLeft}
            onClick={() => {
              changeDisplayImage(false);
            }}
          >
            <ChevronRight />
          </div>
        )}
        {returnSlide(displayedFirstImageIndex)}
        {showSecondImage && returnSlide(displayedSecondImageIndex)}
        {showThirdImage && returnSlide(displayedThirdImageIndex)}
        {showFourthImage && returnSlide(displayedFourthImageIndex)}
        {showArrow && (
          <div
            className={styles.chevronRight}
            onClick={() => {
              changeDisplayImage(true);
            }}
          >
            <ChevronRight />
          </div>
        )}
      </div>
      {!isTabletOrDesktop && <Category title={title} subTitle={subTitle} />}
    </div>
  );
};
